<script lang="ts">
    export let src: string;
    export let text: string;
</script>

<span class="flex items-center xs:mx-auto xs:my-6 sm:mb-8 font-semibold">
    <img class="h-8 w-8" {src} />
    <span class="ml-3 text-3xl">{text}</span>
</span>
